import { createAction } from 'Lib/reduxUtils';

import {
  DYNAMIC_FEATURE_COMPLETE,
  DYNAMIC_REDUCER_COMPLETE,
  LOAD_ASYNC_FEATURES,
} from './constants';

export const dynamicReducerComplete = createAction(
  DYNAMIC_REDUCER_COMPLETE,
  (reducersName: string[]) => reducersName
);

export const loadAsyncFeatures = createAction(LOAD_ASYNC_FEATURES, (names: string[]) => names);

export const dynamicFeatureComplete = createAction(
  DYNAMIC_FEATURE_COMPLETE,
  (name: string) => name
);
